import React from "react";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";

import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="">
        {" "}
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href="">
        <FaFacebookF />
      </a>
    </div>
    <div>
      <a href="https://www.instagram.com/brhnyclen/">
        
        <BsInstagram />
      </a>
    </div>
    <div>
      <a href="https://github.com/yucel1993?tab=overview&from=2023-08-01&to=2023-08-02"
      target="_blank"
      rel="noopener noreferrer">
        <AiFillGithub />
      </a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/burhan-yucel/"
       target="_blank"
       rel="noopener noreferrer"
      >
      
        <AiFillLinkedin />
      </a>
    </div>
  </div>
);

export default SocialMedia;
